import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { StyledJobEditorSection } from "./styles";

type Props = PropsWithChildren<{
    titleKey: string;
    isUnderlined?: boolean;
}>;

const JobEditorSection = ({ children, titleKey, isUnderlined }: Props) => {
    const translate = useTranslation();

    return (
        <StyledJobEditorSection isUnderlined={isUnderlined}>
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {translate(titleKey)}
            </Text>

            {children}
        </StyledJobEditorSection>
    );
};

export default JobEditorSection;
